export default {
      id: "student-app-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#student-app",
      toString: function () {
        return this.url;
      }
    }